const itemSchema = [
  { qty: Number, productId: String, scope: String, parentId: String }
]
export default itemSchema
